import React from 'react';

import { Button } from './button';

export interface ButtonBarProps {
  handleSecondary?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  secondaryText?: string;
  handlePrimary: (event: React.MouseEvent<HTMLButtonElement>) => void;
  primaryText?: string;
  disablePrimary?: boolean;
  disableSecondary?: boolean;
  handleBottomPrimary?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  bottomPrimaryText?: string;
  handleBottomSecondary?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  bottomSecondaryText?: string;
}

export function ButtonBar({
  handleSecondary,
  handlePrimary,
  primaryText,
  secondaryText,
  disablePrimary = false,
  disableSecondary = false,
  handleBottomPrimary,
  bottomPrimaryText,
  handleBottomSecondary,
  bottomSecondaryText
}: ButtonBarProps) {
  return (
    <div className="button-bar">
      <div className="top-row">
        {handleSecondary ? (
          <Button secondary onClick={handleSecondary} disabled={disableSecondary}>
            {secondaryText ?? 'Back'}
          </Button>
        ) : (
          <div />
        )}
        {handlePrimary && (
          <Button disabled={disablePrimary} onClick={handlePrimary}>{primaryText ?? 'Continue'}</Button>
        )}
      </div>
      <div className="bottom-row">
        {handleBottomSecondary && bottomSecondaryText ? (
          <Button onClick={handleBottomSecondary}>
            {bottomSecondaryText}
          </Button>
        ) : (
          <div />
        )}
        {handleBottomPrimary && bottomPrimaryText && (
          <Button onClick={handleBottomPrimary}>
            {bottomPrimaryText}
          </Button>
        )}
      </div>
    </div>
  );
}
